// We use upscale and downscale factor to downscale NEW game assets from 1080p to 720p(game native resolution)
export const UPSCALE_FACTOR = 1.5;
export const DOWNSCALE_FACTOR = 1 / UPSCALE_FACTOR;

/**
 * Downscale 1080p image to 720p(native game resolution)
 *
 * @example
 * new ImageView(
 *   ...
 *   width: downscale(1920),
 *   height: downscale(1080),
 *   ...
 * );
 *
 * @param origin1080pSize - Actual image 1080p image size
 * @param round - Math.floor(default) or Math.ceil to round the result
 */
export function downscale(origin1080pSize: number, round = Math.floor): number {
  return round(origin1080pSize * DOWNSCALE_FACTOR);
}

/**
 * Upscale 720p(native game resolution) image to 1080p
 *
 * @param origin720pSize - Actual image 720p image size
 * @param round - Math.floor or Math.ceil(default) to round the result
 */
export function upscale(origin720pSize: number, round = Math.ceil): number {
  return round(origin720pSize * UPSCALE_FACTOR);
}
